import { Container, Text } from '@doist/marketist'

import { useTranslation } from 'next-i18next'

import Crossfit from './assets/crossfit.svg'
import Mit from './assets/mit.svg'
import RemoteHow from './assets/remote-how.svg'
import Penn from './assets/upenn.svg'

import css from './teams.module.css'

export function Teams() {
    const { t } = useTranslation('slackalternative')

    return (
        <Container width="sm" className={css.teamContainer}>
            <Text className={css.teamTitle} size="minor-lg">
                {t('teams')}
            </Text>
            <ul className={css.customerList}>
                <li>
                    <Mit width={40} height={48} aria-label="MIT" />
                </li>
                <li>
                    <RemoteHow width={154} height={48} aria-label="Remote-How" />
                </li>
                <li>
                    <Penn width={103} height={48} aria-label="University of Pennsylvania" />
                </li>
                <li>
                    <Crossfit width={94} height={48} aria-label="CrossFit" />
                </li>
            </ul>
        </Container>
    )
}
